export default __webpack_public_path__ + "static/media/react.05b5ccb4.png";